import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import classNames from 'classnames/bind';
import React, { useState } from 'react';
import { RiCameraSwitchLine } from 'react-icons/ri';
import { useDispatch } from 'react-redux';
import { v4 as uuidv4 } from 'uuid';

import styles from './common.module.scss';

import actions from '@/actions';
import ConfirmSlider from '@/components/ui/ConfirmSlider';
import Select from '@/components/ui/kit/Select';
import useVideoCommand from '@/hooks/command/dji/useVideoCommand';
import { NotifierService as notifier } from '@/libs/Notifier';
import { executeDJICommand } from '@/utils/CommandUtils';

const cx = classNames.bind(styles);

const LENS_TYPES = [
  // { value: 'normal', label: 'Normal' }, // NOTE: Currently not working for unknown reasons
  { value: 'wide', label: 'Wide' },
  { value: 'zoom', label: 'Zoom' },
  { value: 'ir', label: 'IR' },
];

const Panel = ({ data: robots }) => {
  const dispatch = useDispatch();
  const [selectedLens, setSelectedLens] = useState(LENS_TYPES[0].value);
  const [isProcessing, setProcessing] = useState(false);
  const videoCommand = useVideoCommand();

  //#region Process Functions
  const process = async (robot) => {
    try {
      await executeDJICommand(robot, videoCommand.changeLens(selectedLens));

      onSuccess(robot);
    } catch (error) {
      if (typeof error === 'object' && error?.data?.message) {
        console.debug(error.data.message);
      }
      onFailure(robot);
    }
  };
  //#endregion

  //#region Result Handlers
  const onSuccess = (robot) => {
    notifier.success(`${robot.name} lens changed to ${selectedLens} successsfully.`);
    setProcessing(false);
  };

  const onFailure = (robot) => {
    notifier.error(`Failed to change lens of ${robot.name}.`);
    setProcessing(false);
  };
  //#endregion

  useUpdateEffect(() => {
    if (!isProcessing) {
      dispatch(actions.command.resetActivePanels());
      return;
    }

    process(robots[0]);
  }, [isProcessing]);

  const handleChange = (e) => {
    setSelectedLens(e.target.value);
  };

  const doCommand = () => {
    setProcessing(true);
  };

  return (
    <div className={cx('container')}>
      <div className={cx('desc')}>Changes the lens type for the aircraft's camera</div>
      <div className={cx('form')}>
        <Select name="lens" value={selectedLens} onChange={handleChange}>
          {LENS_TYPES.map((type) => (
            <option key={type.value} value={type.value}>
              {type.label}
            </option>
          ))}
        </Select>
      </div>
      <ConfirmSlider
        width="100%"
        height={40}
        onConfirm={doCommand}
        isProcessing={isProcessing}
        labelStyle={{ fontSize: 12 }}
      />
    </div>
  );
};

const Command = {};
Command.id = uuidv4();
Command.name = 'Change Lens';
Command.displayMode = 'sidebar';
Command.singleRobotOnly = true;
Command.commanderOnly = true;
Command.Icon = RiCameraSwitchLine;
Command.Panel = Panel;

export default Command;
